import { cn } from '@shared/lib/cn';

export interface ProgressBarSkeletonProps {
  className?: string;
}

/** status=init — 막대와 같은 치수(높이 12)의 회색 틀. Figma: `color/bg/pressed`, 모서리 `radius/full` */
export function ProgressBarSkeleton({ className }: ProgressBarSkeletonProps) {
  return (
    <div
      aria-hidden="true"
      data-status="init"
      className={cn('skeleton-pulse', 'h-3 w-full rounded-full bg-bg-pressed', className)}
    />
  );
}
